import { render, staticRenderFns } from "./login_layout.vue?vue&type=template&id=b22e96c4"
import script from "./login_layout.vue?vue&type=script&lang=js"
export * from "./login_layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports